import * as tslib_1 from "tslib";
import React from 'react';
import { findDOMNode } from 'react-dom';
import RippleElement from './RippleElement';
var withRipple = function (rippleConfig) {
    function createEnableRippleComponent(Component) {
        var _a;
        var name = typeof Component === 'string' ? Component : Component.displayName;
        return _a = /** @class */ (function (_super) {
                tslib_1.__extends(EnableRippleComponent, _super);
                function EnableRippleComponent() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                EnableRippleComponent.prototype.componentDidMount = function () {
                    this.createRippleElement();
                };
                EnableRippleComponent.prototype.componentDidUpdate = function (prevProps) {
                    var disabledChanged = prevProps.disabled !== this.props.disabled;
                    if (disabledChanged && this.props.disabled && this.rippleElement) {
                        this.rippleElement.disable();
                    }
                    else if (disabledChanged && !this.props.disabled) {
                        if (!this.rippleElement) {
                            this.createRippleElement();
                        }
                        else {
                            this.rippleElement.enable();
                        }
                    }
                };
                EnableRippleComponent.prototype.componentWillUnmount = function () {
                    if (this.rippleElement) {
                        this.rippleElement.cancel();
                    }
                };
                EnableRippleComponent.prototype.createRippleElement = function () {
                    var element = findDOMNode(this);
                    this.rippleElement = new RippleElement(element, rippleConfig);
                    requestAnimationFrame(function () {
                        var position = window.getComputedStyle(element).position;
                        if (!position || position === 'static') {
                            element.style.position = 'relative';
                        }
                    });
                };
                EnableRippleComponent.prototype.render = function () {
                    return React.createElement(Component, tslib_1.__assign({}, this.props));
                };
                return EnableRippleComponent;
            }(React.Component)),
            _a.displayName = "withRipple(" + name + ")",
            _a.sinouiName = name,
            _a;
    }
    return createEnableRippleComponent;
};
export default withRipple;
//# sourceMappingURL=withRipple.js.map